import { hasVerifiedPaymentTotal } from './paymentReconciliation';

const object = value => value && typeof value === 'object' && !Array.isArray(value);
const text = value => typeof value === 'string' ? value.trim().toUpperCase() : '';
const money = value => Number.isSafeInteger(value) && value >= 0 && value <= 999999999999;
const readyFees = new Set(['charged', 'free', 'fully_subsidized']);
const readyPackages = new Set(['SIAP_TAGIH', 'SIAP_KIRIM', 'TERKIRIM']);
const terminalRefunds = new Set(['SELESAI', 'JADI_DEPOSIT', 'DIBATALKAN', 'TIDAK_BERLAKU_KOREKSI']);
const resolvedOrders = new Set(['DAPAT', 'CANCEL', 'SOLD', 'SOLD_OUT', 'TIDAK_DAPAT']);
const uniqueIds = rows => rows.every(row => object(row) && typeof row.id === 'string' && row.id.trim()) &&
    new Set(rows.map(row => row.id.trim().toUpperCase())).size === rows.length;

// Presentation gate only. The API supplies the selected PO and certified balance.
// Never infer readiness from an invoice badge or calculate a new payable amount.
export function canShowPaymentAccount(data, pending = false) {
    if (pending || !object(data) || !object(data.po) ||
        typeof data.po.id !== 'string' || !/^[A-Za-z0-9_-]{1,80}$/.test(data.po.id)) return false;
    const s = data.summary, status = text(data.po.status);
    if (!object(s) || s.finance_state !== 'available' || s.pending_barang_dapat !== false ||
        !money(s.total_dapat) || s.total_dapat <= 0 || !money(s.total_belanja) ||
        !money(s.sisa_tagihan) || s.sisa_tagihan <= 0 || !hasVerifiedPaymentTotal(data.payment_reconciliation, s) ||
        data.tracking_available !== true || !Array.isArray(data.refunds) || !uniqueIds(data.refunds) ||
        !data.refunds.every(refund => terminalRefunds.has(text(refund.status)))) return false;
    if (status === 'OPEN') return s.total_belanja > 0;
    if (!['CLOSED', 'CLOSE'].includes(status) || !Array.isArray(data.orders) || !data.orders.length ||
        !data.orders.every(order => object(order) && resolvedOrders.has(text(order.status)) &&
            (!Object.prototype.hasOwnProperty.call(order, 'raw_status') || text(order.raw_status) === text(order.status)) &&
            order.quantity_valid === true && Number.isSafeInteger(order.qty) && order.qty > 0)) return false;
    const shipping = data.shipping_summary;
    if (!object(shipping) || shipping.weight_complete !== true || !readyFees.has(shipping.fee_state) ||
        !Number.isSafeInteger(shipping.active_package_count) || shipping.active_package_count <= 0 ||
        !Array.isArray(data.packages) || !uniqueIds(data.packages)) return false;
    const active = data.packages.filter(pkg => pkg.active === true);
    if (active.length !== shipping.active_package_count || !data.packages.every(pkg => pkg.active === true
        ? readyPackages.has(text(pkg.status)) && readyFees.has(pkg.shipping_fee_state) && money(pkg.shipping_net) &&
            (pkg.shipping_fee_state === 'charged' ? pkg.shipping_net > 0 : pkg.shipping_net === 0)
        : pkg.active === false && text(pkg.status) === 'DIBATALKAN')) return false;
    // The same consistency check used by the existing final-readiness display.
    const displayedShipping = active.reduce((sum, pkg) => sum + pkg.shipping_net, 0);
    return money(displayedShipping) && displayedShipping === s.ongkir;
}
